module.exports = __webpack_public_path__ + "static/media/setningsminne-intro.4a65c4a9.mp3";